import request from "@/utils/requestSC";

/* 拼单 */
export async function getGroupBuyingDetail(params) {
  return request.get("/rest/combination_order/api/detail", {
    params
  });
}

/* 拼单-立即加入 */
export async function getConfirmOrder(params) {
  return request.get("/rest/combination_order/api/showConfirmOrderPage", {
    params
  });
}
